import { configureStore } from '@reduxjs/toolkit';
import themeSlice from './themeSlice';

export const store = configureStore({
  reducer: {
    themeSlice: themeSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 